export type UtenlandskForlag = {
  id: string;
  navn: string;
  land: string;
  sprak: string;
  flagg: string;
  arketype: string;
  sjangerVekt: Record<string, number>;
  minSalg: number;
  minAnmeldelsesSnitt: number;
};

const DEFAULT_SJANGER_VEKT = 0.5;

export const UTENLANDS_GENRE_FALLBACK = DEFAULT_SJANGER_VEKT;

export const UTENLANDSKE_FORLAG: ReadonlyArray<UtenlandskForlag> = [
  {
    id: 'penguin-us',
    navn: 'Penguin US',
    land: 'USA',
    sprak: 'engelsk',
    flagg: '🇺🇸',
    arketype: 'Stor amerikansk forlag, vil ha kommersielle vinnere',
    sjangerVekt: {
      LITERARY: 1.0,
      FEELGOOD: 1.0,
      KRIM: 1.0,
      BARNEBOK: 0.5,
      ROMANCE: 0.8,
      NONFICTION: 0.7,
    },
    minSalg: 15_000,
    minAnmeldelsesSnitt: 4.0,
  },
  {
    id: 'vintage-uk',
    navn: 'Vintage UK',
    land: 'UK',
    sprak: 'engelsk',
    flagg: '🇬🇧',
    arketype: 'Prestige-forlag som vil ha det stillferdig og litterært',
    sjangerVekt: {
      LITERARY: 1.0,
      POETRY: 1.0,
      NONFICTION: 1.0,
      KRIM: 0.7,
      FEELGOOD: 0.4,
    },
    minSalg: 12_000,
    minAnmeldelsesSnitt: 4.5,
  },
  {
    id: 'suhrkamp',
    navn: 'Suhrkamp',
    land: 'Tyskland',
    sprak: 'tysk',
    flagg: '🇩🇪',
    arketype: 'Intellektuelt tysk forlag, høyt kritikerblikk',
    sjangerVekt: {
      LITERARY: 1.0,
      NONFICTION: 1.0,
      POETRY: 1.0,
      KRIM: 0.6,
      FEELGOOD: 0.3,
    },
    minSalg: 10_000,
    minAnmeldelsesSnitt: 4.5,
  },
  {
    id: 'gallimard',
    navn: 'Gallimard',
    land: 'Frankrike',
    sprak: 'fransk',
    flagg: '🇫🇷',
    arketype: 'Klassisk fransk litteratur-forlag med stor katalog',
    sjangerVekt: {
      LITERARY: 1.2,
      POETRY: 1.0,
      NONFICTION: 0.8,
      KRIM: 0.7,
      FEELGOOD: 0.4,
    },
    minSalg: 10_000,
    minAnmeldelsesSnitt: 4.5,
  },
  {
    id: 'anagrama',
    navn: 'Anagrama',
    land: 'Spania',
    sprak: 'spansk',
    flagg: '🇪🇸',
    arketype: 'Indie litterært forlag fra Barcelona, kuratert smak',
    sjangerVekt: {
      LITERARY: 1.0,
      POETRY: 1.0,
      NONFICTION: 0.8,
      KRIM: 0.7,
      FEELGOOD: 0.5,
    },
    minSalg: 10_000,
    minAnmeldelsesSnitt: 4.0,
  },
  {
    id: 'hayakawa',
    navn: 'Hayakawa',
    land: 'Japan',
    sprak: 'japansk',
    flagg: '🇯🇵',
    arketype: 'Krim, sci-fi og spenning for det japanske markedet',
    sjangerVekt: {
      KRIM: 1.2,
      FANTASY: 1.2,
      LITERARY: 0.6,
      FEELGOOD: 0.4,
      BARNEBOK: 0.4,
    },
    minSalg: 12_000,
    minAnmeldelsesSnitt: 4.0,
  },
  {
    id: 'reservoir',
    navn: 'Reservoir',
    land: 'Mexico',
    sprak: 'spansk',
    flagg: '🇲🇽',
    arketype: 'Massemarked for hele Latin-Amerika, jakter feelgood og romanse',
    sjangerVekt: {
      FEELGOOD: 1.2,
      ROMANCE: 1.2,
      KRIM: 0.9,
      LITERARY: 0.6,
      POETRY: 0.3,
    },
    minSalg: 15_000,
    minAnmeldelsesSnitt: 4.0,
  },
  {
    id: 'bonniers-se',
    navn: 'Bonniers SE',
    land: 'Sverige',
    sprak: 'svensk',
    flagg: '🇸🇪',
    arketype: 'Naboforlag med lav terskel for norsk litteratur',
    sjangerVekt: {
      LITERARY: 1.0,
      KRIM: 1.0,
      FEELGOOD: 1.0,
      BARNEBOK: 1.0,
      NONFICTION: 1.0,
      POETRY: 1.0,
      ROMANCE: 1.0,
      FANTASY: 1.0,
    },
    minSalg: 5_000,
    minAnmeldelsesSnitt: 4.0,
  },
];

export function finnUtenlandskForlag(id: string): UtenlandskForlag | undefined {
  return UTENLANDSKE_FORLAG.find((f) => f.id === id);
}

export function sjangerVektFor(forlag: UtenlandskForlag, sjanger: string): number {
  const norm = sjanger.trim().toUpperCase();
  return forlag.sjangerVekt[norm] ?? UTENLANDS_GENRE_FALLBACK;
}
